import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

const OPTIONS = [
  { value: "nouveau", label: "Nouveau" },
  { value: "a_contacter", label: "A contacter" },
  { value: "contacte", label: "Contacte" },
  { value: "ignore", label: "Ignore" },
];

export function StatusSelect({ value, onChange, testId }) {
  return (
    <Select value={value} onValueChange={onChange}>
      <SelectTrigger data-testid={testId} className="rounded-none h-8 w-[140px] font-mono text-xs uppercase">
        <SelectValue />
      </SelectTrigger>
      <SelectContent className="rounded-none">
        {OPTIONS.map((o) => (
          <SelectItem key={o.value} value={o.value} data-testid={`${testId}-option-${o.value}`} className="font-mono text-xs uppercase">
            {o.label}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
